<template>
  <div class="text-center" data-cy="base-dialog-button">
    <v-btn
      :icon="buttonText === undefined && buttonIcon !== undefined"
      :color="color"
      v-bind="$attrs"
      :disabled="disabled || isSending"
      data-cy="open-dialog-btn"
      @click="openDialog()"
    >
      <template v-if="!isSending">
        <v-icon v-if="buttonIcon !== undefined" :left="buttonText !== undefined">
          {{ buttonIcon }}
        </v-icon>
        <template v-if="buttonText !== undefined">
          {{ buttonText }}
        </template>
      </template>
      <v-progress-circular v-else color="grey" indeterminate>
      </v-progress-circular>
    </v-btn>
    <v-dialog :value="active" :width="width" persistent>
      <v-card>
        <v-card-title class="headline background"> {{ title }}</v-card-title>

        <v-divider></v-divider>
        <v-layout column justify-center align-center>
          <v-card-text>
            <div class="px-2">
              <p>{{ content }}</p>
            </div>
            <v-row v-if="!canUndo" justify="center">
              <strong>{{ i18n.t("__CFA2_ApproveAction") }}</strong>
            </v-row>
            <v-row class="px-4" v-if="askRemember">
              <v-checkbox
                v-model="checked"
                data-cy="chk-confirmCommands"
                :label="i18n.t('_DontShowDialogAnymore')"
              ></v-checkbox>
            </v-row>
          </v-card-text>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions class="py-3">
          <v-btn text @click="cancel" data-cy="btn-cancel"
            >{{ i18n.t("_Cancel") }}
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="!isSending"
            :color="color"
            :disabled="disabled"
            @click="confirm"
          >
            {{ title }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import i18n from "../helper/i18n"
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    buttonIcon: {
      type: String,
    },
    buttonText: {
      type: String,
    },
    canUndo: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "primary",
    },
    askRemember: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "450",
    },
    showDialog: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
      checked: false,
      isSending: false,
      i18n: i18n
    };
  },
  computed: {
    active() {
      return this.dialog && this.showDialog;
    },
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    openDialog() {
      this.dialog = true;
      if (this.dialog === true && !this.showDialog) {
        this.confirm();
      }
    },
    confirm() {
      const that = this;
      this.dialog = false;
      this.$emit("confirmed");
      this.isSending = true;

      if (this.checked) {
        this.$emit("deactivated");
      }
      setTimeout(() => {
        that.isSending = false;
      }, 2000);
    },
  },
};
</script>
